<template>
  <div id="Comment">
    <a-comment :author="data_comment.author">
      <!-- 功能 -->
      <template #actions>
        <!-- 是否喜欢 -->
        <span key="comment-basic-like" v-if="data_comment.children">
          <a-tooltip title="喜欢">
            <template v-if="data_comment.action === 'liked'">
              <LikeFilled @click="data_like_fn('liked',data_comment.id)"/>
            </template>
            <template v-else>
              <LikeOutlined @click="data_like_fn('dislike',data_comment.id)"/>
            </template>
          </a-tooltip>
          <span style="padding-left: 8px; cursor: auto">
            {{ data_comment.likes?data_comment.likes:'0' }}
          </span>
        </span>
        <!-- 回复 -->
        <span key="comment-basic-reply-to" @click="data_reply_fn(data_comment)">回复</span>
      </template>
      <!-- 姓名 -->
      <template #author><a class="commentName">{{data_comment.author}}</a></template>
      <!-- 头像 -->
      <template #avatar>
        <a-avatar :size="36" :src="data_comment.avatar" :alt="data_comment.author"/>
      </template>
      <!-- 内容 -->
      <template #content>
        <p>{{data_comment.content}}</p>
      </template>
      <!-- 发布时间 -->
      <template #datetime >
        <a-tooltip v-if="data_comment.datetime" :title="data_comment.datetime.format('YYYY-MM-DD HH:mm:ss')">
          <span>{{ /几秒/.test(data_comment.datetime.fromNow())?'刚刚':data_comment.datetime.fromNow() }}</span>
        </a-tooltip>
      </template>
      <!-- 子评论 -->
      <template v-if="data_comment.children && data_comment.children.length">
        <Comment v-for="(child,key) in data_comment.children" :data_comment="child" :data_reply_fn="data_reply_fn" :data_index="key" :key="key"/>
      </template>
    </a-comment>
  </div>
</template>

<script>
  import {Comment, avatar, tooltip, Input} from 'ant-design-vue';
  import {LikeFilled, LikeOutlined, DislikeFilled, DislikeOutlined} from '@ant-design/icons-vue';

  export default {
    name: "Comment",
    components: {
      [Comment.name]: Comment,
      [avatar.name]: avatar,
      [tooltip.name]: tooltip,
      [Input.TextArea.name]: Input.TextArea,
      LikeFilled,
      LikeOutlined,
      DislikeFilled,
      DislikeOutlined,
    },
    props: ['data_comment','data_reply_fn','data_like_fn'],
  }
</script>

<style scoped lang="scss">
  /* 评论两侧边距************ */
  .comment-list {
    padding: 0 20px;
  }

  /* 评论头像大小 */
  :deep(.ant-comment-avatar img) {
    width: 100%;
    height: 100%;
  }
</style>
